import {
  Datagrid,
  Edit,
  EditButton,
  List,
  Loading,
  SimpleForm,
  TextField,
  TextInput,
  TranslatableInputs,
  useGetList,
} from "react-admin";

const recommendationTextFilters = [
  <TextInput key="goal" source="goal__icontains" label="Goal" alwaysOn />,
  <TextInput key="action" source="action__icontains" label="Action" alwaysOn />,
  <TextInput key="key" source="id__icontains" label="Key" alwaysOn />,
];

export const GeoffreyRecommendationTextsList = () => (
  <List filters={recommendationTextFilters} sort={{ field: "id", order: "ASC" }}>
    <Datagrid bulkActionButtons={false}>
      <TextField source="goal" />
      <TextField source="action" />
      <TextField source="geoffreyExplanationTextKey" label="Key" />
      <EditButton />
    </Datagrid>
  </List>
);

export const GeoffreyRecommendationTextsEdit = () => {
  const { data: locales = [], isLoading, error } = useGetList(
    'locales'
  );
  if (isLoading) { return <Loading />; }
  if (error) { return <p>Error</p>}
  
  const localeCodes = locales.map((l) => l.pk);
  return (
    <Edit mutationMode="pessimistic">
      <SimpleForm>
        <TextInput source="goal" disabled fullWidth />
        <TextInput source="action" disabled fullWidth />
        <TextInput source="geoffreyExplanationTextKey" label="Key" disabled fullWidth />

        <TranslatableInputs locales={localeCodes} defaultLocale="en-GB" groupKey="recommendationLabel" fullWidth>
          <TextInput source="recommendationLabel" label="Recommendation Label" fullWidth />
          <TextInput source="recommendationExplanation" label="Recommendation Explanation" multiline minRows={4} fullWidth />
        </TranslatableInputs>
      </SimpleForm>
    </Edit>
  )
};
